/**
 * Last-seen error envelope captured by the axios 5xx interceptor and
 * surfaced on the `/500` view's reference strip + body copy.
 *
 * Lives in its own Pinia store rather than the SessionExpiredOverlay
 * machinery because it carries the *server's* envelope (`req_id`, `ts`,
 * `env`, `detail`) — values support engineers paste into tickets. The
 * `SessionExpiredOverlay` handles its own 401 lifecycle and never touches
 * this store.
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorStore = defineStore('error', () => {
  const lastReqId = ref<string>('')
  const lastTs = ref<string>('')
  const lastEnv = ref<string>('')
  const lastDetail = ref<string>('')

  function setFromResponse(req_id: string, ts: string, env: string, detail: string): void {
    lastReqId.value = req_id
    lastTs.value = ts
    lastEnv.value = env
    lastDetail.value = detail
  }

  function reset(): void {
    lastReqId.value = ''
    lastTs.value = ''
    lastEnv.value = ''
    lastDetail.value = ''
  }

  return { lastReqId, lastTs, lastEnv, lastDetail, setFromResponse, reset }
})
